import { Modal } from "reactstrap";
import { useNetwork } from "../../NetworkContext";

const InternetStatusModal = () => {
  const { isOffline } = useNetwork();

  return (
    <Modal isOpen={isOffline} backdrop="static" centered>
      <div className="p-4 text-center">
        <div className='d-flex flex-column justify-content-center gap-3'>
          <i className='bx bx-wifi-off text-muted' style={{ fontSize: "50px" }}></i>
          <h2 className='text-center'>No Internet Connection</h2>
          <p className='text-muted text-center'>
            Please check your connection. We couldn't detect an active internet connection.
          </p>
          <div className='d-flex gap-1 justify-content-center'>
            <p className='text-muted text-center'>
              Waiting for connection
            </p>
            <div className='internet-connection-loader mb-2'></div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default InternetStatusModal;
